import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { ExtraService } from '../../core/services/extra.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from '../../core/config/Constants';
import { UtilityService } from '../../core/services/utility.service';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { MultiUtilityService } from '../../core/services/multi-utility.service';
import { Category } from '../../core/models/category';
import { error } from 'util';
import { OrganizersService } from '../../core/services/organizers.service';
import { Organizer } from '../../core/models/organizer';
import { HideImage } from '../../core/models/hideImage';
import { Listing } from '../../core/models/listing';
import { MultiUtility } from '../../shared/multi-utility';
import { NewPageService } from '../../templates/new-page/service/new-page.service';

import * as firebase from 'firebase/app';
import { FileUpload, Checkbox } from 'primeng/primeng';
import { ExportImportSpeakersService } from '../../core/services/export-import-speakers.service';
import { DatePipe } from '@angular/common';
import { EventsService } from '../../core/services/events.service';

@Component({
	selector: 'app-organizer-list',
	templateUrl: './organizer-list.component.html',
	styleUrls: ['./organizer-list.component.css'],
	providers: [ExtraService, UtilityService, OrganizersService,NewPageService,ExportImportSpeakersService,DatePipe,EventsService]
})
export class OrganizerListComponent extends MultiUtility implements OnInit {

	eventID: string;
	message: string;

	categoryItemNewText: string = null;
	categoryList: Array<Category> = new Array();
	categoryDeletedIdList: Array<string> = new Array();

	organizerId: string;
	organizersList: Array<Organizer> = [];

	checkData: boolean = false;

	hasListOrderChanged: boolean = false;
	hasCategoryOrderChanged: boolean = false;

	listing = new Listing();
	hideImage = new HideImage();
	checkAll:boolean=false;
	
	checkedList: Array<any> = new Array();
	
	bannerImageFile: File = null;
	organizer = new Organizer();
	
	selectedFile: File = null;
	/** new added */
	errorMessages: string;
	
	allOrganizer = new Array<Organizer>();
	aliasId = "Organizers"
	
	newImportOrganizer = new Array<Organizer>();
	
	keys = {
		id: "Id",
		name: "Name",
		type: "Type",
		email: "Email",
		phoneNo: "Phone No",
		designation: "Designation",
		isEmailVisible: "Is Email Visible",
		isPhoneNoVisible: "Is Phone Visible"
	};

	constructor( extraService: ExtraService,private route: ActivatedRoute,
		private confirmationService: ConfirmationService,  multiUtilityService: MultiUtilityService,private eximSpeakersService: ExportImportSpeakersService,private eventsService: EventsService,
		private organizerService: OrganizersService,newPageService: NewPageService, _cfr: ComponentFactoryResolver, private _multiUtilityService: MultiUtilityService) {
			super(multiUtilityService, extraService, newPageService, _cfr);
		// super();
	}

	ngOnInit() {
		this.extraService.changeStateofSideBarButton(true);
		this.extraService.changeSideBar(true);
		this.route.params.subscribe(params => {
			if (params['eventId']) {
				this.eventID = params['eventId'];
				this.extraService.setCurrentEventId(params['eventId']);
				this.checkData = true;
				this.initCategoryList(params['eventId']);
				this.getOrganizersList(params['eventId']);
				
				this.getEventAliasId(params['eventId']);

				this._multiUtilityService.getPrefListing(params['eventId'], Constants.LIST_CATEGORY_ORGANIZER).subscribe(pref => {
					this.listing.has_category_organizer = pref;
				});

				this._multiUtilityService.getPrefHiding(params['eventId'], Constants.HIDE_IMAGE_ORGANIZER).subscribe(pref => {
					this.hideImage.hideImageOrganizer = pref;
				});
			}
		});
	}

	getEventAliasId(id) {
		this.eventsService.getEventBasicInfo(id).subscribe(event => {
			if (event) {
				this.aliasId = event.aliasId;
			}
		})
	}

	getOrganizersList(eventId: string) {
		let x = this.organizerService.getOrganizersList(eventId);
		x.snapshotChanges().subscribe(list => {
			if (this.checkData) {
				this.organizersList = [];
				list.forEach(element => {
					let y = element.payload.toJSON() as Organizer;
					y["$key"] = element.key;
					this.organizersList[y.position] = (y as Organizer);
				});
				console.log(this.organizersList);
				this.checkData = false;
			}
		});
	}

	selectUnselectAll() {
		console.log(this.checkAll);
		if (this.checkAll) {
			let arr = [];
			this.organizersList.forEach(element => {
				// console.log(element.$key);
				arr.push(element.$key);
			});
			this.checkedList = arr;
		} else {
			this.checkedList = new Array();
		}
	}

	confirmDeleteMultipleListItem() {
		// Get Checked Item Count
		let i = 0;
		let all_checkbox = document.querySelectorAll(".poll-data input[type=checkbox]")
		for(let j = 0 ;j < all_checkbox.length; j++){
			if((all_checkbox[j] as HTMLInputElement).checked)
				i++;
		}
		console.log(i);

		this.confirmationService.confirm({
			message: Constants.DELETE_MSG_MULTIPLE_SPEAKER(i),
			accept: () => {
				this.deleteAllSelected();
			}
		});
	}

	deleteAllSelected() {
		console.log('deleteAllSelected');
		// this.confirmDeleteListItem(event: Speaker, value: string);
		this.checkedList.forEach(element => {
			// console.log(element);
			let selectedItem = this.organizersList.find(item => item.$key === element);
			// console.log(selectedItem);
			this.deleteListItem(selectedItem);
		});
	}
	/* drag n drop for list start */

	dropHandlerNew(fileList, event, speakerIndex){

		console.log("Speaker Index", speakerIndex);
		this.uploadImageNew(fileList, event, speakerIndex);
	

	}


	dropzoneState($event: boolean, event) {
		//console.log("DropZoneActive",$event, event);
	}

	uploadImageNew(event, _organizer, _organizerIndex){


		console.log('Source Logo :: ', _organizer);
		this.bannerImageFile = event.files[0];
		console.log('Source bannerImageFile :: ', this.bannerImageFile);
		this.getOrganizerById(_organizer);

		this.uploadImageToStoragePromise(this.bannerImageFile, firebase, this.organizer, this.eventID, Constants.CONTENT_M_TYPE_ORGANIZERS, Constants.IMAGE_UPLOAD_TYPE_BANNER).then(d=>{

			console.log("Response from FXN", d);
			console.log(this.organizer, this.eventID, _organizer.$key, d);
			if (this.validate(this.organizer)) {

				this.organizerService.updateOrganizerDetails(this.organizer, this.eventID, _organizer.$key).then(res => {
					
					alert("Upload Done");
					this.getOrganizersList(this.eventID)
					console.log("res", d);
					console.log('Update Successfully');

				}).catch(error => {
					console.log('Update Failed');
				});
			} else {
				console.log('Update Failed else');
			}

		});
		

	}
	
	validateFileNameField(speakers: any): boolean {
		let breakLoop: boolean;
		speakers.some(el => {
			if (el[this.keys['name']] !== undefined || !breakLoop) {
				if (el[this.keys['name']] === '' || el[this.keys['name']].length < 2) {
					breakLoop = true;
				}
			} else {
				breakLoop = true;
			}
		});

		if (breakLoop) return false;
		else return true;
	}

	validateFileData(speakers: any): number {
		let count = 0;
		speakers.some(el => {
			if (el[this.keys['id']] !== undefined) {
				count++;
			};
		});
		return count;
	}

	validateExcelVal(obj: any, key: string) {
		if (typeof obj[key] == 'string') obj[key] = obj[key].trim();
		console.log(key, obj[key], 'qqqqqq');
		return (obj[key] != undefined && obj[key] != '') ? obj[key] : null;
	}
	
	importOrganizer(event: any, uploader: FileUpload) {
		//debugger
		let bulkUploadTrigger: boolean = false;
		this.selectedFile = event.files[0];
		this.eximSpeakersService.importSpeakers(this.selectedFile).then(organizers => {

			if (!this.validateFileNameField(organizers)) {
				this.errorMessages = 'It seems, some records don\'t have name value or name length should greater or equal to two character. Please fix before update.';
				setTimeout(() => {
					this.removeFileInstance(event, uploader, 0);
					this.errorMessages = null;
				}, 2000);
			} else {
				this.allOrganizer = [];
				let allOrganizerCount: number = 0
				// all db speakers details
				this.organizerService.getAllOrganizers(this.eventID).then((list) => {
					list = list.val();
					if (list) {
						allOrganizerCount = Object.keys(list).length;
						for (let val in list) {
							this.allOrganizer[val] = list[val];
						}
					}

					// speakers operation
					this.newImportOrganizer = [];
					let detail: any,
						newOrganizerIdCount = this.validateFileData(organizers);

					if (allOrganizerCount != newOrganizerIdCount) {
						this.errorMessages = 'It seems, you don\'t have latest organizers list file. Please export organizers list before update.';
						setTimeout(() => {
							this.removeFileInstance(event, uploader, 0);
							this.errorMessages = null;
						}, 2000);
					}
					else {
						this.message = "Processing File";
						if (!newOrganizerIdCount) {
							organizers.forEach((speaker, key) => {
								this.addOrganizer(speaker);
								if ((+key + 1) === organizers.length) bulkUploadTrigger = true;
							});
						} else {
							organizers.forEach((organizer, key) => {
								// id value exist
								if (organizer[this.keys['id']] != undefined) {
									detail = this.allOrganizer[organizer[this.keys['id']]];
									// update
									detail['position'] = (+organizer['__rowNum__'] - 1);
									detail['name'] = this.validateExcelVal(organizer, this.keys['name']);
									detail['type'] = this.validateExcelVal(organizer, this.keys['type']);
									detail['email'] = this.validateExcelVal(organizer, this.keys['email']);
									detail['phoneNo'] = this.validateExcelVal(organizer, this.keys['phoneNo']);
									detail['designation'] = this.validateExcelVal(organizer, this.keys['designation']);
									let isEmailVisible = '' + this.validateExcelVal(organizer, this.keys['isEmailVisible']);
									detail['isEmailVisible'] = isEmailVisible ? (isEmailVisible.toLowerCase() == 'true' ? true : false) : false;
									let isPhoneNumberVisible = '' + this.validateExcelVal(organizer, this.keys['isPhoneNoVisible']);
									detail['isPhoneNoVisible'] = isPhoneNumberVisible ? (isPhoneNumberVisible.toLowerCase() == 'true' ? true : false) : false;
									this.allOrganizer[organizer[this.keys['id']]] = detail;
								} else {
									this.addOrganizer(organizer);
								}
								if ((+key + 1) === organizers.length) bulkUploadTrigger = true;
							});
						}
					}

					// db operation call
					setInterval(() => {
						if (bulkUploadTrigger) {
							this.removeFileInstance(event, uploader, 0);
							this.bulkUploadOrganizers();
							bulkUploadTrigger = false;
						}
					}, 1000);

				});
			}
		}, error => {
			this.errorMessages = error;
			setTimeout(() => {
				this.errorMessages = null;
			}, 2000);
		});
	}

	bulkUploadOrganizers() {
		this.message = 'Organizers Import Successfully';
		if (this.allOrganizer) {
			this.organizerService.addBulkOrganizers(this.allOrganizer, this.eventID);
		}
		if (this.newImportOrganizer) {
			this.newImportOrganizer.forEach(organizer => {
				this.organizerService.addOrganizerDetails(organizer, this.eventID);
			});
		}

		setTimeout(() => {
			this.message = null;
			this.checkData = true;
			this.getOrganizersList(this.eventID);
		}, 1000);
	}

	addOrganizer(speaker: any) {
		let detail = new Organizer();
		detail.position = (+speaker['__rowNum__'] - 1);
		detail.name = this.validateExcelVal(speaker, this.keys['name']);
		detail.type = this.validateExcelVal(speaker, this.keys['type']);
		detail.email = this.validateExcelVal(speaker, this.keys['email']);
		detail.phoneNo = this.validateExcelVal(speaker, this.keys['phoneNo']);
		detail.designation = this.validateExcelVal(speaker, this.keys['designation']);
		let isEmailVisible = '' + this.validateExcelVal(speaker, this.keys['isEmailVisible']);
		detail.isEmailVisible = isEmailVisible ? (isEmailVisible.toLowerCase() == 'true' ? true : false) : false;
		let isPhoneNumberVisible = '' + this.validateExcelVal(speaker, this.keys['isPhoneNoVisible']);
		detail.isPhoneNoVisible = isPhoneNumberVisible ? (isPhoneNumberVisible.toLowerCase() == 'true' ? true : false) : false;
		this.newImportOrganizer.push(detail);
	}


	removeFileInstance(event: any, uploader: FileUpload, index: number) {
		uploader.remove(event.files[0], 0);
	}

	getOrganizerById(event) {
		this.organizer = event;
		this.organizer = new Organizer();
		this.organizer.name = event.name;
		this.organizer.position = event.position;
		this.organizer.email = event.email === undefined ? null : event.email;
		this.organizer.type = event.type === undefined ? null : event.type;
		this.organizer.bannerCMId = event.bannerCMId === undefined ? null : event.bannerCMId;
		this.organizer.bannerUrl = event.bannerUrl === undefined ? null : event.bannerUrl;
		this.organizer.isEmailVisible = event.isEmailVisible === undefined ? null : event.isEmailVisible;
		this.organizer.isPhoneNoVisible = event.isPhoneNoVisible === undefined ? null : event.isPhoneNoVisible;
		this.organizer.phoneNo = event.phoneNo === undefined ? null : event.phoneNo;
		this.organizer.designation = event.designation === undefined ? null : event.designation;

		this.organizer.aboutList = event.aboutList === undefined ? [] : event.aboutList;


		if (this.organizer.aboutList) {
			//
		} else {
			this.organizer.aboutList = [];
		}
		return this.organizer;
	}

	exportOrganizers() {
		//debugger
		// getAll
		this.allOrganizer = [];
		let data: any;
		// all db speakers details
		this.organizerService.getAllOrganizers(this.eventID).then((list) => {
			list = list.val();
			if (list) {
				for (let val in list) {
					data = {};
					data[this.keys['id']] = val;
					data[this.keys['name']] = list[val].name;
					data[this.keys['type']] = list[val].type == undefined ? "":list[val].type;
					data[this.keys['email']] = list[val].email== undefined ? "":list[val].email;
					data[this.keys['phoneNo']] = list[val].phoneNo== undefined ? "":list[val].phoneNo;
					data[this.keys['designation']] = list[val].designation== undefined ? "":list[val].designation;
					data[this.keys['isEmailVisible']] = list[val].isEmailVisible ? 'true' : 'false';
					data[this.keys['isPhoneNoVisible']] = list[val].isPhoneNoVisible ? 'true' : 'false';
					this.allOrganizer[list[val].position] = data;
				}
				this.eximSpeakersService.generateFile(this.allOrganizer, this.aliasId,'organizer');
			}
		});
	}

	/* drag n drop for list end */
	dragEnter($event){
		$event.target.style.border = "3px dotted red";
		console.log("Drag Enter", $event);
	}
	dragLeave($event){
		$event.target.style.border = "";
		console.log("Drag Leave", $event);
	}
	dropDone($event){
		$event.target.style.border = "";
		$event.target.classList.add("busy");
	}



	selectSpeaker(item) {
		console.log(item.$key);
		if (this.checkedList.indexOf(item.$key) != -1) {
			let index = this.checkedList.indexOf(item.$key);
			this.checkedList.splice(index, 1);
		} else {
			this.checkedList.push(item.$key);
		}
		console.log(this.checkedList);
	}

	/*	CATEGORY RELATED FUNCTIONS	*/
	initCategoryList(eventId) {
		this._multiUtilityService.getCategoryList(eventId, Constants.CATEGORY_ORGANIZERS).subscribe(event => {
			if (event) {
				this.categoryList = new Array();
				for (let key in event) {
					let categoryItem = new Category();
					categoryItem.$key = key;
					categoryItem.position = event[key].position;
					categoryItem.text = event[key].text;
					this.categoryList[event[key].position] = categoryItem;
				}
				console.log('initCategoryList	:	' + this.categoryList.length);
			}
		});
	}

	onCategoryTextChange() {
		console.log("jnkjn");
		this.hasCategoryOrderChanged = true;
	}

	addCategoryItem() {
		if (this.categoryItemNewText != null && this.categoryItemNewText.trim().length > 0) {
			this.hasCategoryOrderChanged = true;

			let categoryItem = new Category();
			categoryItem.$key = null;
			categoryItem.position = this.categoryList.length;
			categoryItem.text = this.categoryItemNewText;
			this.categoryList.push(categoryItem);

			// Commented by Pranav
			for (var i = 0; i < this.categoryList.length; i++) {
				this.categoryList[i].position = i;
			}

			let key = this._multiUtilityService.addCategoryItem(this.eventID, this.categoryList, Constants.CATEGORY_ORGANIZERS);
			if (key) {
				this.message = 'Type Added Successfully';
				this.categoryItemNewText = null;
				setTimeout(() => {
					this.message = null;
					this.checkData = true;
				}, 1000);
			}
		}
	}

	upCategoryItem(index) {
		if (index != 0) {
			this.swapCategoryItem(index, index - 1);
		}
	}

	downCategoryItem(index) {
		if (index != this.categoryList.length - 1) {
			this.swapCategoryItem(index, index + 1);
		}
	}

	swapCategoryItem(index1, index2) {
		this.hasCategoryOrderChanged = true;

		let data = this.categoryList[index1];
		this.categoryList[index1] = this.categoryList[index2];
		this.categoryList[index2] = data;
	}

	confirmDeleteCategoryItem(item) {
		this.confirmationService.confirm({
			message: Constants.DELETE_MSG_SPONSOR + ' ' + item.text,
			accept: () => {
				this.deleteCategoryItem(item);
			}
		});
	}

	deleteCategoryItem(item) {
		this.hasCategoryOrderChanged = true;

		this.categoryDeletedIdList.push(item.$key);
		let index: number = this.categoryList.indexOf(item);
		if (index !== -1) {
			/* Remove category from List */
			this.categoryList.splice(index, 1);

			/* Reset position in categoryList */
			for (var i = 0; i < this.categoryList.length; i++) {
				this.categoryList[i].position = i;
			}
		}
	}

	/*	CATEGORY RELATED FUNCTIONS - END	*/

	/* <T> object related functions */
	upListItem(index) {
		console.log("testtt");
		if (index != 0) {
			this.swapListItem(index, index - 1);
		}
	}

	downListItem(index) {
		if (index != this.organizersList.length - 1) {
			this.swapListItem(index, index + 1);
		}
	}

	swapListItem(index1, index2) {
		this.hasListOrderChanged = true;

		let data = this.organizersList[index1];
		this.organizersList[index1] = this.organizersList[index2];
		this.organizersList[index2] = data;
	}

	confirmDeleteListItem(event: Organizer, value: string) {
		this.confirmationService.confirm({
			message: Constants.DELETE_MSG_EXH,
			accept: () => {
				this.deleteListItem(event);
			}
		});
	}

	deleteListItem(event: Organizer) {
		this.hasListOrderChanged = true;

		let index: number = this.organizersList.indexOf(event);
		if (index !== -1) {
			this.organizersList.splice(index, 1);
			for (var i = 0; i < this.organizersList.length; i++) {
				this.organizersList[i].position = i;
			}
		}

		this.organizerService.deleteOrganizer(event, this.eventID, this.organizersList).then(res => {
			this.message = "Organizer deleted Successfully";
			setTimeout(() => {
				this.message = null;
				this.checkData = true;
				this.getOrganizersList(this.eventID);
			}, 1000);
		}).catch(error => {
			console.log(error.message);
		});
	}
	/* <T> object related functions */

	submit() {
		console.log("		hasCategoryOrderChanged		" + this.hasCategoryOrderChanged + "hasListOrderChanged	" + this.hasListOrderChanged);
		if (this.hasListOrderChanged) {
			/* Reset position of List from 0 */
			for (var i = 0; i < this.organizersList.length; i++) {
				this.organizersList[i].position = i;
			}

			// TODO: Use a callback
			this.organizerService.updateOrganizerPosition(this.eventID, this.organizersList);
			this.message = "Sponsors Updated";

			setTimeout(() => {
				this.message = null;
				this.checkData = true;
			}, 2000);
		}

		if (this.hasCategoryOrderChanged) {
			for (let i = 0; i < this.categoryList.length; i++) {
				this.categoryList[i].position = i;
			}
			let key = this._multiUtilityService.addCategoryItem(this.eventID, this.categoryList, Constants.CATEGORY_ORGANIZERS);
			if (this.categoryDeletedIdList.length > 0) {
				for (let item of this.categoryDeletedIdList) {
					this._multiUtilityService.deleteCategoryItem(this.eventID, item, Constants.CATEGORY_ORGANIZERS).then(res => {
						this.message = 'Type deleted Successfully';
						if (this.categoryDeletedIdList.indexOf(item) == this.categoryDeletedIdList.length) {
							this.initCategoryList(this.eventID);
						}
					});
				}
			} else {
				this.message = 'Type ordered Successfully';
			}
			setTimeout(() => {
				this.message = null;
				this.checkData = true;
			}, 2000);
		}

		this._multiUtilityService.updatePrefListing(this.eventID, Constants.LIST_CATEGORY_ORGANIZER, this.listing.has_category_organizer);
		this._multiUtilityService.updatePrefHiding(this.eventID, Constants.HIDE_IMAGE_ORGANIZER, this.hideImage.hideImageOrganizer);

	}
}


// WEBPACK FOOTER //
// /app/src/app/event/organizer-list/organizer-list.component.ts